export default __webpack_public_path__ + "poe-icon.png";